import { createSharedComposable, useRefHistory } from "@vueuse/core";
import { computed, readonly, ref } from "vue";
import { max } from "@/common/lib/array";

function useDotnetLoadingProgressFn() {
  const loadedCount = ref(0);
  const totalCount = ref(0);

  function setProgress({ loaded, total }: { loaded: number; total: number }) {
    loadedCount.value = loaded;
    totalCount.value = total;
  }

  const progress = computed(() => {
    if (totalCount.value === 0) return 0;
    return loadedCount.value / totalCount.value;
  });

  // total number of resources may increase, bringing percentage value back
  // to avoid that track progress history and always take the maximum value
  const { history } = useRefHistory(progress);
  const maxProgress = computed(() => max(history.value, s => s.snapshot) ?? 0);

  return {
    setProgress,
    loadedCount: readonly(loadedCount),
    totalCount: readonly(totalCount),
    progress: maxProgress,
  };
}

export const useDotnetLoadingProgress = createSharedComposable(useDotnetLoadingProgressFn);
